<template>
  <v-row class="fill-height">
    <v-col>
      <transition name="fade-up" mode="out-in" appear>
        <router-view></router-view>
      </transition>
    </v-col>
  </v-row>
</template>

<script>

export default {
  name: 'Media',

  data: () => ({
    
  }),
};
</script>
